export enum GameObjectEvents {
  LIVE_TYPING = 'Object Live Typing',
  PARSE_LINKS = 'Game Object Parse Links',
};
